// composables/useLabelKey.ts
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export function useLabelKey(localeMapping: Record<string, string>) {
  const { locale } = useI18n()

  const labelKey = computed(() => {
    return localeMapping[locale.value] || localeMapping['default'] || 'nameEn'
  })

  return labelKey
}
